type RouteConfig = {
  path: string;
  name?: string;
};

type Config = {
  app: {
    name: string;
    domainName: string;
    url: string;
  };
  routes: {
    signin: RouteConfig;
    dashboard: RouteConfig;
    verifyRequest: RouteConfig;
    error: RouteConfig;
    settings: RouteConfig;
    history: RouteConfig;
    analysis: RouteConfig;
    advanced: RouteConfig;
    leaderboard: RouteConfig;
  };
  email: {
    support: string;
    login: string;
  };
  social: {
    x: string;
  };
  userAgent: string;
};

const APP_URL =
  process.env.NEXTAUTH_URL ||
  process.env.NEXT_PUBLIC_APP_URL ||
  "http://localhost:3000";

export const config: Config = {
  app: {
    name: "YourWebsiteScore",
    domainName: new URL(APP_URL).hostname,
    url: APP_URL,
  },
  routes: {
    signin: { path: "/signin" },
    verifyRequest: { path: "/verify-request", name: "Verify Request" },
    error: { path: "/error" },
    dashboard: { path: "/dashboard", name: "Dashboard" },
    settings: { path: "/settings", name: "Settings" },
    history: { path: "/history", name: "History" },
    analysis: { path: "/analysis", name: "Analysis" },
    advanced: { path: "/advanced", name: "Advanced" },
    leaderboard: { path: "/leaderboard", name: "Leaderboard" },
  },
  email: {
    support: "andi@yourwebsitescore.com",
    login: "login@yourwebsitescore.com",
  },
  social: {
    x: "andi_losing",
  },
  userAgent: "Mozilla/5.0 (compatible; YourWebsiteScoreBot/1.0)",
};

export default config;
